import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getMenuPermissions } from '../../helpers/api_helper';

const useObtenerMenuPermissions = (refresh = 0) => {
    const [menuPermissions, setMenuPermissions] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const tenantId = useSelector((state) => state.Context.tenantId);
    const empresa = useSelector((state) => state.Context.empresa);

    useEffect(() => {
        const fetchMenuPermissions = async () => {
            if (!tenantId || !empresa) return;

            setLoading(true);
            setError(null);
            try {
                const response = await getMenuPermissions({
                    tenantId, empresa
                });
                setMenuPermissions(response);
            } catch (err) {
                const errorMessage = `Failed to fetch menu permissions: ${err.message || 'Unknown error'}`;
                setError(errorMessage);
                console.error(errorMessage);
                setMenuPermissions(null);
            } finally {
                setLoading(false);
            }
        };

        fetchMenuPermissions();
    }, [tenantId, empresa, refresh]);

    return { menuPermissions, loading, error };
};

export default useObtenerMenuPermissions;